
import React, { Component } from "react";
import styled from "styled-components";
import TableCell from "@material-ui/core/TableCell";


const StyledTableCellStatus = styled(TableCell)`
  font-size: 12px;
  vertical-align: top;
  padding-top: 8px;
  width: 140px;
  white-space: nowrap;
  
  .status {
     font-weight: bold;
  }
`;

const Divider = styled.div`
  background: rgba(224, 224, 224, 0.5);
  height: 1px;
  margin: 1px 0;
`;


export default class TableCellStatus extends Component {
  render() {
    const { item } = this.props;
    return (
      <StyledTableCellStatus>
        <div className={'status'}>
          {item.order_status ? item.order_status.label : '-'}
        </div>
        <Divider />
        <div
          className={'status'}
          style={{color: `${item.order_payment_status ? item.order_payment_status.color : ''}`}}
        >
          {item.order_payment_status ? item.order_payment_status.label : '-'}
        </div>
      </StyledTableCellStatus>
    )
  }
}
